/** @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#making_a_generic_replacer */
export function interpolateUrl(string: string, values: Record<string, any>) {
  return string.replace(
    /{(.*?)}/g,
    (_, offset) => values[offset],
  );
}

/**
 * Strips the trailing slash from the url
 * @param {Optional: String} url
 * @returns {Optional: String}
 */
export function normalizeUrl<T extends string | undefined>(url: T): T {
  if (!url) {
    return url;
  }
  if (url.slice(-1) === '/') {
    return url.slice(0, -1) as T;
  }
  return url;
}
